<template lang="pug">
k-button(
  v-bind="$data.$_attrs"
  v-on="$data.$_listeners"
  outlined
).k-button--outline
  slot
</template>

<script>
import { BindsAttrs } from '@/mixins'

export default {
  mixins: [ BindsAttrs ]
}
</script>


<style lang="scss" scoped>
.k-button {
  border: 2px solid;
}
</style>
